import { recommendations } from "../actionContants";
import { IGetAllRecommendationsResponse } from "./recommendations.d";

export function getAllRecommendationsResponseAction(payload: any): IGetAllRecommendationsResponse {
	return {
		type: recommendations.GET_ALL_RECOMMENDATIONS_RESPONSE,
		payload
	};
}
